
export function Separator() {
  return <div className='pcy-separator'></div>
}
